import { useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { BookOpen, ChevronDown } from "lucide-react";
import { LOYALTY_ARTICLE } from "../lib/loyaltyArticle";

const MD = {
  h2: ({ children }) => <h3 className="font-heading font-900 text-xl text-amber-700 mt-8 mb-3">{children}</h3>,
  p: ({ children }) => <p className="text-base leading-relaxed text-zinc-700 mb-4">{children}</p>,
  ul: ({ children }) => <ul className="list-disc pl-5 space-y-1.5 text-base text-zinc-700 mb-4">{children}</ul>,
  li: ({ children }) => <li>{children}</li>,
  strong: ({ children }) => <strong className="font-700 text-zinc-900">{children}</strong>,
  em: ({ children }) => <em className="italic text-zinc-600">{children}</em>,
  a: ({ href, children }) => <a href={href} target="_blank" rel="noreferrer" className="text-primary hover:underline">{children}</a>,
  table: ({ children }) => <div className="overflow-x-auto mb-4"><table className="w-full border-collapse text-sm">{children}</table></div>,
  th: ({ children }) => <th className="border border-zinc-200 bg-zinc-50 px-3 py-2 text-left font-700">{children}</th>,
  td: ({ children }) => <td className="border border-zinc-200 px-3 py-2 align-top">{children}</td>,
};

export default function LoyaltyArticle() {
  const [open, setOpen] = useState(false);
  const a = LOYALTY_ARTICLE;
  return (
    <div id="guide" className="border border-amber-200 bg-white scroll-mt-24" data-testid="loyalty-article">
      <div className="p-6 border-b border-amber-100 bg-amber-50/50">
        <div className="text-xs font-mono uppercase tracking-widest text-amber-600 mb-2 flex items-center gap-2"><BookOpen className="w-4 h-4" /> {a.eyebrow}</div>
        <h2 className="font-heading font-900 text-2xl sm:text-3xl tracking-tight">{a.title}</h2>
        <p className="mt-3 text-zinc-600 max-w-3xl">{a.intro}</p>
        <button onClick={() => setOpen((o) => !o)} data-testid="loyalty-article-toggle"
          className="inline-flex items-center gap-1.5 mt-4 bg-amber-500 text-white px-4 py-2.5 text-sm font-600 hover:bg-amber-600 transition-colors">
          <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
          {open ? "Hide the full guide" : "Read the full guide"}
        </button>
      </div>
      {open && (
        <div className="p-6 lg:p-8 max-w-none" data-testid="loyalty-article-body">
          <ReactMarkdown remarkPlugins={[remarkGfm]} components={MD}>{a.markdown}</ReactMarkdown>
        </div>
      )}
    </div>
  );
}
